cafm.rb.form = {
    getRoomBooking: function () {
        return cafm.views.getMainFormViewModel()
    },
    setupRoomSearch: function (locality) {
        
        // place and setup toolbar
        cafm.forms.placeMainFormToolbar();
        $('.mainToolbar').setupToolbar();

        // RB settings
        var rbs = cafm.getClientSettings().roomBookingSettings;
        var cs = rbs.calendarWindowStart;
        var ce = rbs.calendarWindowEnd;
        var duration = rbs.defaultBookingDuration;

        // set working vars
        var startTime, endTime, now = cafm.web.funcs.getSessionDateTimeNow();
        now.setSeconds(0, 0);

        // add 30 mins onto now for start time
        startTime = cafm.util.addMinutes(now, 30);
        var startMins = startTime.getMinutes();

        // round down to 0 if 1-29
        if (startMins > 0 && startMins < 30) {

            startTime.setMinutes(0);
        }
        // round down to 30 if over 30 mins
        else if (startMins > 30) {

            startTime.setMinutes(30);
        }

        // check we're not outside the working calendar, if we set start to nearest available time
        if (startTime.getHours() > ce.getHours() || (startTime.getHours() == ce.getHours() && startTime.getMinutes() >= ce.getMinutes())) {

            // later than the calendar day end, set to first available tomorrow
            startTime = cafm.util.addMinutes(now, 60 * 24);
            startTime.setHours(cs.getHours());
            startTime.setMinutes(cs.getMinutes());
        }
        else if (startTime.getHours() < cs.getHours() || (startTime.getHours() == ce.getHours() && startTime.getMinutes() < cs.getMinutes())) {

            // earlier than the calendar day start, set to first available today
            startTime.setHours(cs.getHours());
            startTime.setMinutes(cs.getMinutes());
        }

        // add duration onto start for end
        endTime = cafm.util.addMinutes(startTime, duration);

        // if end time exceeds the max then set to max
        if (endTime.getHours() > ce.getHours() || (endTime.getHours() == ce.getHours() && endTime.getMinutes() > ce.getMinutes())) {

            endTime.setHours(ce.getHours());
            endTime.setMinutes(ce.getMinutes());
        }
        
        var criteria = locality;
        $.extend(criteria, {
            StartDate: cafm.util.truncateToDate(new Date(startTime.valueOf())),
            StartTime: startTime,
            StartDateTime: startTime,
            EndTime: endTime,
            EndDateTime: endTime,
            IsBookableOnIntranet: cafm.enums.DefaultableBooleanData.True
        });

        // bind the locality to the hierarchy control
        cafm.views.bindMainFormViewModel(criteria);

        // get the newly bound viewmodel
        criteria = cafm.views.getMainFormViewModel();

        // bind the set field handler function
        criteria.bind('set', cafm.rb.form.handlers.field.setField);

        // setup the hierarchy control
        var locWidget = $('.sideWidget.localityWidget');
        criteria = cafm.hi.casc.setup(locWidget, criteria);
        cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, criteria, cafm.hi.casc.getAllowedLocalityDepth(), locWidget);

        // get the main form element
        var mainForm = cafm.views.getMainForm();
        var layDrop = mainForm.find('[name="RoomLayoutCodeID"]');

        if (layDrop.length) {

            // bind change event to the viewmodel
            criteria.bind('change', function (args) {

                if (args.field != 'LocationID') {

                    return;
                }

                var lid = args.sender.source.LocationID;
                if (!cafm.util.guidHasValue(lid)) {

                    lid = cafm.auth.companyId();
                }

                var items = layDrop.data('items');
                var kLayDrop = layDrop.data('kendoDropDownList');
                var filtered = cafm.util.filterItemsByLocationId(items, lid, true);
                kLayDrop.setDataSource(new kendo.data.DataSource({
                    data: filtered
                }));

                if (cafm.util.guidHasValue(criteria.RoomLayoutCodeID)) {

                    var exists = cafm.util.exists(filtered, function (layout) { return layout.value == criteria.RoomLayoutCodeID; });

                    if (!exists) {

                        criteria.set('RoomLayoutCodeID', cafm.guid.empty);
                    }
                    else {

                        kLayDrop.value(criteria.RoomLayoutCodeID);
                        kLayDrop.trigger('change');
                    }
                }
            });
        }

        // set the min / max for the kendo controls once the form has loaded (kendo controls intialised)
        setTimeout(function () {
            
            var st = $('#startTimeField_StartTime').data('kendoTimePicker');
            var et = $('#endTimeField_EndTime').data('kendoTimePicker');

            // hook up all day checkbox
            $('#IsAllDay').on('change', function (e) {

                var vm = cafm.views.getMainFormViewModel();
                var isAllDay = $(e.currentTarget).isChecked();

                st.enable(!isAllDay);
                et.enable(!isAllDay);

                if (isAllDay) {

                    var newStart = new Date(vm.StartTime);
                    newStart.setHours(cs.getHours());
                    newStart.setMinutes(cs.getMinutes());
                    vm.set('StartTime', newStart);

                    var newEnd = new Date(vm.EndTime);
                    newEnd.setHours(ce.getHours());
                    newEnd.setMinutes(ce.getMinutes());
                    vm.set('EndTime', newEnd);
                }
            });

            // set min and max times for the room search
            st.min(cs);
            st.max(ce);
            et.min(cs);
            et.max(ce);

            if (layDrop.length) {

                var lid = cafm.util.guidHasValue(criteria.LocationID) ? criteria.LocationID : criteria.CompanyID;
                var items = layDrop.data('items');
                var kLayDrop = mainForm.find('[name="RoomLayoutCodeID"]').data('kendoDropDownList');
                var filtered = cafm.util.filterItemsByLocationId(items, lid, true);
                kLayDrop.setDataSource(new kendo.data.DataSource({
                    data: filtered
                }));
            }
        }, 250);
    },
    initBookingForm: function(pnl){

        cafm.forms.placeMainFormToolbar();
        $('.mainToolbar').setupToolbar();
        
        let settings = cafm.rb.settings;
        if (settings.costCodeExactLength || settings.costCodeMinLength || settings.costCodeMaxLength)
            cafm.rb.form.helpers.applyCostCodeRestriction();
    },
    loadBookingForm: function(){

        var roomBooking = cafm.views.getMainFormViewModel();
        var isConf = cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingConfirmation);

        // ensure these are dates now as we use them a lot later
        cafm.util.ensureDates(roomBooking, ['MinTime', 'MaxTime']);

        // bind the set field handler function
        roomBooking.bind('set', cafm.rb.form.handlers.field.setField);

        cafm.actions.setObjectInContextId(roomBooking.ID);

        var oi = $('#optionalInfo');
        oi.showHideDataBoundFields(roomBooking);
        roomBooking.bind('change', function () {

            oi.showHideDataBoundFields(roomBooking);
        });

        // make loclaity trail a bit more readable
        var lt = $('#LocalityTrail');
        $('#LocalityTrail').text(lt.text().replace(/\\/g, ' \\ '));

        // RB settings
        var rbs = cafm.getClientSettings().roomBookingSettings;

        // enable editing of optional info
        if (!roomBooking.IsReadOnly) {

            // hook up booked by changed event
            $('#contactLookup').data('onLookupSelected', cafm.rb.form.handlers.misc.contactLookupSelected);

            cafm.rb.form.helpers.appendEditLink({
                target: $('#optionalInfo > header'),
                handler: function (e) {

                    cafm.views.openActionWindow({
                        url: cafm.url.get('RoomBooking/EditBookingOptionalInfo'),
                        method: 'GET',
                        isForm: true,
                        viewModel: cafm.views.getMainFormViewModel().toJSON(),
                        winOptions: {
                            width: 600,
                            height: 500,
                            title: cafm.res.str.TitleOptionalInformation
                        },
                        onLoad: cafm.rb.form.handlers.optional.load
                    });
                }
            });

            let bookingDateTimeField = $("#bookingDateTime");
            if (rbs.equipmentSecuritySetting == cafm.enums.SecuritySetting.Full) {
                cafm.rb.form.helpers.appendAddLink({
                    target: $('#equipment > header'),
                    handler: () => {
                        if (bookingDateTimeField.validateElement()) {
                            cafm.views.openActionWindow({
                                url: cafm.url.get('RoomBooking/AddEquipment'),
                                method: 'GET',
                                isForm: true,
                                winOptions: {
                                    width: 600,
                                    height: isTouch ? 460 : 450
                                },
                                onInit: cafm.rb.eq.handlers.add.init,
                                onLoad: cafm.rb.eq.handlers.add.load
                            });
                        }
                        else {
                            cafm.msg.showMessageInWindow({
                                type: cafm.enums.MessageType.Error,
                                title: cafm.res.str.MessageValidBookingDateMustBeSpecified
                            });
                        }
                    }
                });
            }

            if (rbs.serviceSecuritySetting == cafm.enums.SecuritySetting.Full && bookingDateTimeField.validateElement()) {
                cafm.rb.form.helpers.appendAddLink({
                    target: $('#services > header'),
                    handler: () => {
                        if (bookingDateTimeField.validateElement()) {
                            cafm.views.openActionWindow({
                                url: cafm.url.get('RoomBooking/AddService'),
                                method: 'GET',
                                isForm: true,
                                winOptions: {
                                    width: 600,
                                    height: isTouch ? 460 : 450
                                },
                                onInit: cafm.rb.svc.handlers.add.init,
                                onLoad: cafm.rb.svc.handlers.add.load
                            });
                        }
                        else {
                            cafm.msg.showMessageInWindow({
                                type: cafm.enums.MessageType.Error,
                                title: cafm.res.str.MessageValidBookingDateMustBeSpecified
                            });
                        }
                    }
                });
            }

            $('#attendeeName').data('onLookupSelected', cafm.rb.att.handlers.addAttendeeLookupSelected);
            $('#attendeeAddBtn').click(cafm.rb.att.handlers.addAttendee);

            cafm.rb.att.helpers.toggleNotifyAttendeesCheckbox(cafm.util.hasItem(roomBooking.Attendees));
                        
        }
        else {

            if (!cafm.util.hasItem(roomBooking.Equipment)) {

                $('#equipment').hide();
            }
            else if (isConf && rbs.equipmentSecuritySetting >= cafm.enums.SecuritySetting.View) {

                $('#equipment .cGrd').data('kendoGrid').expandRow('.k-master-row');
            }

            if (!cafm.util.hasItem(roomBooking.Services)) {

                $('#services').hide();
            }
            else if (isConf && rbs.serviceSecuritySetting >= cafm.enums.SecuritySetting.View) {

                $('#services .cGrd').data('kendoGrid').expandRow('.k-master-row');
            }

            if (!cafm.util.hasItem(roomBooking.Attendees)) {

                $('#attendees').hide();
            }
            else if (isConf) {

                $('#attendees .cGrd').data('kendoGrid').expandRow('.k-master-row');
            }

            $('#attendeeFilters').hide();
        }

        // show recurring booking indicator
        if (roomBooking.IsRecurringBooking && !roomBooking.IsAdhocPattern) {

            cafm.rb.form.helpers.showRecurringLink(roomBooking);
        }

        // enable adding of ad-hoc date times
        var bdt = $('#bookingDateTime');
        if (rbs.allowMultipleOccurrences && !roomBooking.IsReadOnly && !roomBooking.IsRecurringBooking && !roomBooking.IsVarianceBooking) {

            cafm.rb.form.helpers.appendAddLink({
                id: 'addBookingTimes',
                target: bdt,
                handler: function (e) {

                    cafm.views.openActionWindow({
                        url: cafm.url.get('RoomBooking/EditBookingAdHocTimes'),
                        method: 'GET',
                        isForm: true,
                        winOptions: {
                            width: 600,
                            height: 450
                        },
                        onLoad: cafm.rb.form.handlers.adhoc.load
                    });
                }
            });
        }

        // display ad-hoc / recurring date times
        if (cafm.util.hasItem(roomBooking.BookingDateTimes)) {

            if (!isConf) {

                cafm.rb.form.helpers.showBookingDateTimesLink(cafm.util.hasItem(roomBooking.BookingDateTimes) && roomBooking.IsAdhocPattern);
            }

            if (roomBooking.IsAdhocPattern) {

                cafm.rb.form.helpers.renderBookingDateTimes(roomBooking);
                $('#bookingTimesContainer').show();
            }
        }

        // show confirmation message if flag is present
        if (cafm.rb.form.bookingConfirmed) {

            $('#' + cafm.res.consts.ElementId_MainForm).showMessage({

                Type: cafm.enums.MessageType.Success,
                Title: cafm.res.str.MessageRoomBookingIsConfirmed
            });

            delete cafm.rb.form.bookingConfirmed;
        }

        // render any number of messages on load
        cafm.msg.showFormMessages({

            clientData: roomBooking
        });

        // show any number of clashes on load
        cafm.rb.form.helpers.showClashesIfAny(roomBooking);

        // add the booking to the client history
        if (!roomBooking.IsNew) {
            cafm.rb.form.helpers.addHistory(roomBooking);
        }
    },
    startNewBooking: function (room, bookingInfo) {

        var params;
        if (isNullOrUndefined(bookingInfo)) {
            
            var search = cafm.views.getMainFormViewModel();

            params = {

                RoomId: room.ID,
                RoomDescription: room.Description,
                StartDateTime: search.BookedFrom,
                EndDateTime: search.BookedTo,
                ManualAttendees: search.CapacityFrom,
                IsAllDay: search.IsAllDay
            }
        }
        else {

            params = {
                
                RoomId: room.ID,
                RoomDescription: room.Description,
                StartDateTime: bookingInfo.StartDateTime,
                EndDateTime: bookingInfo.EndDateTime,
                Description: bookingInfo.Description,
                ContactEmail: bookingInfo.ContactEmail,
                DepartmentID: bookingInfo.DepartmentID,
                CostCode: bookingInfo.CostCode
            }
        }
        
        // cache parameters so these can be used on navigate
        cafm.rb.form.selectedRoom = params;

        // navigate to new booking form
        cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingNewBooking);
    },
    handlers: {

        adhoc: {

            add: function (e) {

                cafm.rb.form.helpers.addAdhocDatetime({

                    roomBooking: cafm.views.getMainFormViewModel()
                });
            },
            cancel: function () {

                cafm.toolbar.standardActionToolbar.cancel();
            },
            expand: function(){
                
                var bt = $('#bookingTimesList');

                if (!bt.children().length) {

                    cafm.rb.form.helpers.renderBookingDateTimes(cafm.views.getMainFormViewModel());
                }

                cafm.rb.form.helpers.toggleBookingTimes();
            },
            load: function (panel) {

                var rb = cafm.views.getMainFormViewModel();
                var existingDateTimes = rb.BookingDateTimes;

                panel.find('.cfLabel').remove();

                var fieldSet = panel.find('.cFieldSet');
                var fieldGroup = panel.find('.fieldGroup');

                cafm.rb.form.helpers.modifyAdHocFieldGroup(fieldGroup);

                var fgHtml = fieldGroup.html();
                fieldSet.data('fieldsHtml', fgHtml);
                fieldSet.data('count', 1);
                
                cafm.rb.form.helpers.appendAddLink({
                    id: 'addBookingTime',
                    target: fieldGroup,
                    handler: cafm.rb.form.handlers.adhoc.add
                });

                fieldGroup.find('.cfField:not(.cfChildField)').append($('<div />', {

                    id: 'adHocDateMsg',
                    'class': 'adHocValPlc'
                }));

                panel.prepareForm();
                panel.closest('.actionWindow').find('.cTb').setupToolbar();
                
                var rb = cafm.views.getMainFormViewModel(),
                    start, end, avm,
                    hasExisting = cafm.util.hasItem(existingDateTimes);

                if(hasExisting) {

                    var first = existingDateTimes[0];

                    if (cafm.util.dateTimesAreSame(rb.StartDateTime, first.StartDateTime)) {

                        if (existingDateTimes.length > 1) {

                            first = existingDateTimes[1];
                            existingDateTimes.shift();
                        }
                        else {

                            first = null;
                        }
                    }

                    if (first) {

                        avm = {

                            StartDate: new Date(first.StartDateTime),
                            StartTime: new Date(first.StartDateTime),
                            EndTime: new Date(first.EndDateTime)
                        };
                    }
                }

                if(!avm) {

                    avm = {

                        StartTime: new Date(rb.StartDateTime),
                        EndTime: new Date(rb.EndDateTime)
                    };
                }

                cafm.views.bindActionWindowViewModel(avm);

                cafm.rb.form.helpers.setMinDatePickers(fieldGroup, rb.StartDateTime);
                cafm.rb.form.helpers.setMinMaxTimePickers(fieldGroup, rb.MinTime, rb.MaxTime);

                if (hasExisting) {

                    $.each(existingDateTimes, function (index, adhocItem) {

                        if (index == 0) return true;

                        cafm.rb.form.helpers.addAdhocDatetime({

                            roomBooking: rb,
                            startDateTime: adhocItem.StartDateTime,
                            endDateTime: adhocItem.EndDateTime
                        });
                    });
                }
            },
            ok: function () {

                var vm = cafm.views.getActionWindowViewModel();
                var actionForm = cafm.views.getActionForm();

                var count = actionForm.find('.cFieldSet').data('count');
                var dateTimes = [];
                var valid = true;
                var roomBooking = cafm.views.getMainFormViewModel();

                // now cycle each date and make sure the from/to dates are added to the collection with correct naming
                for (var i = 0; i < count; i++) {

                    if (i > 0 && actionForm.find('[name="StartDate{0}"]'.format(i)).length == 0) {

                        continue;
                    }

                    var suffix = i > 0 ? i : '';
                    var sd = vm['StartDate' + suffix], st = vm['StartTime' + suffix], et = vm['EndTime' + suffix];
                    
                    if (sd) {

                        if (st) {

                            st.setFullYear(sd.getFullYear());
                            st.setMonth(sd.getMonth(), sd.getDate());
                        }

                        if (et) {

                            et.setFullYear(sd.getFullYear());
                            et.setMonth(sd.getMonth(), sd.getDate());
                        }
                    }

                    var res = cafm.rb.helpers.isValidBookingDate({

                        startDate: sd,
                        start: st,
                        end: et,
                        validationTarget: 'adHocDateMsg' + suffix,
                        performAdhocChecks: true,
                        roomBooking: roomBooking,
                        dateTimes: dateTimes
                    });

                    if (res.valid) {

                        var item = cafm.rb.form.helpers.ensureServerBookingDates(vm, i);
                        dateTimes.push(item);
                    }
                    else {

                        valid = false;                        
                    }
                }

                if (!valid || !dateTimes.length) return;

                dateTimes.sort(function (a, b) {

                    return a.StartDateTime.valueOf() - b.StartDateTime.valueOf();
                });

                roomBooking.set('BookingDateTimes', dateTimes);

                cafm.rb.form.helpers.renderBookingDateTimes(roomBooking);
                cafm.rb.form.helpers.showBookingDateTimesLink(true);
                $('#bookingTimesContainer').show();
                cafm.views.closeActionWindow();
            },
            remove: function (e) {

                var remBtn = $(e.currentTarget);
                var fg = remBtn.closest('.fieldGroup');
                var fs = fg.closest('.cFieldSet');
                var vm = cafm.views.getActionWindowViewModel();
                var fgi = fg.data('index');

                if (fgi) {

                    delete vm['StartDate' + fgi];
                    delete vm['StartTime' + fgi];
                    delete vm['EndTime' + fgi];
                }

                kendo.unbind(fg);
                fg.remove();
            },
            removeRecentlyAdded: function (e) {

                var rb = cafm.views.getMainFormViewModel();
                var remBtn = $(e.currentTarget);

                var itemToRemove = $('#bookingTimesList').data('kendoListView').dataSource.getByUid(remBtn.parent().data('uid'));

                cafm.util.removeWhere(rb.BookingDateTimes, function (item) {

                    return cafm.util.dateTimesAreSame(itemToRemove.StartDateTime, item.StartDateTime);
                });

                cafm.rb.form.helpers.renderBookingDateTimes(rb);

                if (!cafm.util.hasItem(rb.BookingDateTimes)) {

                    $('#IsRecurringBooking').setCheckboxDisabled(false);
                    rb.set('IsRecurringOrAdhoc', false);
                }
            }
        },
        basic: {

            advancededit: function () {

                var roomBooking = cafm.views.getActionWindowViewModel();

                if (roomBooking && roomBooking.RoomBookingId) {

                    cafm.views.closeActionWindows();
                    cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingEditBooking, {
                        bookingId: roomBooking.RoomBookingId
                    });
                }
                else if (roomBooking) {
                    
                    var serverDateTime = cafm.rb.form.helpers.ensureServerBookingDates(roomBooking);

                    if (serverDateTime) {

                        roomBooking.set(serverDateTime);

                        var room = cafm.util.find(cafm.rb.scheduler.rooms, function (r) {

                            return r.ID == roomBooking.RoomId;
                        });

                        cafm.rb.form.startNewBooking(room, roomBooking);

                        var crf = $('#calendarRoomFilters');
                        kendo.destroy(crf);
                        crf.remove();
                    }
                }
            },
            createbooking: function (e) {

                var roomBooking = cafm.views.getActionWindowViewModel();
                var serverDateTime = cafm.rb.form.helpers.ensureServerBookingDates(roomBooking);

                // if the date & time isn't complete or isn't valid it may be null
                if (serverDateTime) {

                    roomBooking.set(serverDateTime);
                }

                // set ID on booking
                roomBooking.set('ID', cafm.actions.getObjectInContextId());

                // perform standard submit trigger handlers on this object, e.g. validate and success
                cafm.toolbar.standardActionToolbar.submit(e);
            },
            cancel: function (e) {

                cafm.toolbar.standardActionToolbar.cancel(e);
            },
            conflict: function (res) {

                cafm.msg.showFormMessages({

                    clientData: res,
                    parent: cafm.views.getActionForm()
                });

                if (cafm.util.hasItem(res.Clashes)) {

                    cafm.rb.form.helpers.showClashes({

                        clashes: res.Clashes
                    });
                }
            },
            createvariance: e => {

                let roomBooking = cafm.views.getActionWindowViewModel();

                if (roomBooking) {

                    cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingVarianceBooking, {
                        bookingId: roomBooking.RoomBookingId,
                        occurrenceId: roomBooking.ScheduleOccurrenceId
                    });
                }
            },
            deletebooking: function (e) {
                cafm.util.yesNoDialogue({
                    message: cafm.res.str.MessageDeleteRoomBooking,
                    yesHandler: function () {
                        var actionFormPlc = cafm.views.getActionForm();
                        cafm.actions.execute({
                            url: cafm.url.api('RoomBooking/DeleteBooking'),
                            values: cafm.util.idData(cafm.actions.getObjectInContextId()),
                            elementId: actionFormPlc.attr('id'),
                            loaderTarget: '[data-key=DeleteBooking]',
                            preventValidate: true,
                            success() {
                                cafm.rb.scheduler.refreshSchedulerDataSource();
                                cafm.views.closeActionWindow();
                            }
                        });
                    }
                });
            },
            deleteoccurrence() {

                cafm.util.yesNoDialogue({

                    message: cafm.res.str.MessageDeleteOccurrence,
                    yesHandler: function () {

                        var actionFormPlc = cafm.views.getActionForm();

                        cafm.actions.execute({

                            url: cafm.url.api('RoomBooking/DeleteBookingOccurrence'),
                            values: cafm.util.createParentChildId(cafm.actions.getObjectInContextId(), actionFormPlc.getViewModel().ScheduleOccurrenceId),
                            elementId: actionFormPlc.attr('id'),
                            loaderSelector: '[data-key=DeleteOccurrence]',
                            preventValidate: true,
                            success() {
                                cafm.rb.scheduler.refreshSchedulerDataSource();
                                cafm.views.closeActionWindow();
                            }
                        });
                    }
                });
            },
            checkinoutoccurrence() {                
                var actionFormPlc = cafm.views.getActionForm();
                var rb = actionFormPlc.getViewModel();
                var checkInOutButton = $('button[data-key="CheckInOutOccurrence"]');
                
                var isCheckedIn = checkInOutButton.text() === cafm.res.str.CheckInOccurrence ? false : true;
                var currentTime = cafm.web.funcs.getSessionDateTimeNow();                
                if (isCheckedIn && rb.StartDate.getTime() >= currentTime) {
                    cafm.util.yesNoDialogue({
                        message: cafm.res.str.MessageDeleteBookingIfCheckOutNotAllowded,
                        yesHandler: function () {                          
                            if (rb.IsRecurringOccurrence) {
                                cafm.actions.execute({
                                    url: cafm.url.api('RoomBooking/DeleteBookingOccurrence'),
                                    values: cafm.util.createParentChildId(cafm.actions.getObjectInContextId(), actionFormPlc.getViewModel().ScheduleOccurrenceId),                                                                     
                                    preventValidate: true,
                                    success() {
                                        cafm.rb.scheduler.refreshSchedulerDataSource();
                                        cafm.views.closeActionWindow();
                                    }
                                });
                            }
                            else {
                                cafm.actions.execute({
                                    url: cafm.url.api('RoomBooking/DeleteBooking'),
                                    values: cafm.util.idData(cafm.actions.getObjectInContextId()),                                                                  
                                    preventValidate: true,
                                    success() {
                                        cafm.rb.scheduler.refreshSchedulerDataSource();
                                        cafm.views.closeActionWindow();
                                    }
                                });
                            }
                        }
                    });                   
                }
                else {
                    cafm.util.yesNoDialogue({
                        message: isCheckedIn ? cafm.res.str.MessageConfirmCheckOutBookingOccurrence : cafm.res.str.MessageConfirmCheckInBookingOccurrence,
                        yesHandler: function () {

                            cafm.actions.execute({
                                url: cafm.url.api('RoomBooking/CheckInOutOccurrence'),
                                values: cafm.util.createParentChildId(cafm.actions.getObjectInContextId(), actionFormPlc.getViewModel().ScheduleOccurrenceId),
                                elementId: actionFormPlc.attr('id'),
                                loaderSelector: '[data-key=CheckInOutOccurrence]',
                                preventValidate: true,
                                success() {
                                    cafm.rb.scheduler.refreshSchedulerDataSource();
                                    cafm.views.closeActionWindow();
                                }
                            });
                        }
                    });
                }                
            },
            success: function (roomBooking, action) {

                cafm.rb.form.helpers.addHistory(roomBooking);
                cafm.rb.scheduler.refreshSchedulerDataSource();
                cafm.views.closeActionWindow();
            },
            updatebooking: function (e) {

                var roomBooking = cafm.views.getActionWindowViewModel();
                var serverDateTime = cafm.rb.form.helpers.ensureServerBookingDates(roomBooking);                

                // if the date & time isn't complete or isn't valid it may be null
                if (serverDateTime) {

                    roomBooking.set(serverDateTime);
                }

                // set ID and basic update flag
                roomBooking.set({
                    ID: cafm.actions.getObjectInContextId(),
                    IsBasicUpdate: true
                });

                // perform standard submit trigger handlers on this object, e.g. validate and success
                cafm.toolbar.standardActionToolbar.submit(e);
            },
            validate(action) {
                let settings = cafm.rb.settings;
                if (settings.costCodeExactLength || settings.costCodeMinLength || settings.costCodeMaxLength) {
                    action.set("valid", cafm.rb.form.helpers.validateCostCode());
                }
                if (action.get('valid')) {
                    //Change dates to UTC
                    cafm.rb.form.helpers.changeBookingStartEndToUTCOnSave(cafm.views.getActionWindowViewModel());
                    return true;
                }
            }
        },
        field: {

            BookingDateTimes(args) {

                var rb = cafm.views.getMainFormViewModel();
                rb.set('IsRecurringOrAdhoc', cafm.util.hasItem(args.value));
            },
            IsRecurringBooking: function (args) {

                var rb = cafm.views.getMainFormViewModel();

                if (args.value === false) {

                    rb.set('RecurrencePattern', null);
                    rb.set('IsRecurringOrAdhoc', false);

                    // remove edit recurrence elements
                    $('#IsRecurringBooking').parent().find('.editLink').remove();
                    $('#recurrenceLink').remove();

                    // show add booking times as this is valid now
                    $('#addBookingTimes').show();

                    // hide the recurrence string
                    $('#recurrenceString').hide();
                }
                else {

                    rb.set('IsRecurringOrAdhoc', true);
                    cafm.recurrence.handlers.openForm({
                       
                        StartDateTime: rb.StartDateTime,
                        EndDateTime: rb.EndDateTime                        
                    }, cafm.rb.form.handlers.main.recurrenceUpdated, cafm.rb.form.handlers.main.recurrenceWindowClosed);
                }
            },
            RoomId(args) {

                cafm.actions.execute({
                    url: cafm.url.api("roombooking/synchronisebooking"),
                    values: cafm.views.getMainFormViewModel(),
                    loaderSelector: "#mainContentPane",
                    success(booking) {
                        cafm.util.ensureDates(booking, ["StartDateTime", "EndDateTime"]);
                        cafm.rb.form.helpers.rebindBooking(booking);
                    }
                });
            },
            StartDate: function (args) {

                var vm = args.sender;

                if (args.value) {

                    if (vm.StartDateTime) {

                        vm.StartDateTime.setFullYear(args.value.getFullYear(), args.value.getMonth(), args.value.getDate());
                    }

                    if (vm.EndDateTime) {

                        vm.EndDateTime.setFullYear(args.value.getFullYear(), args.value.getMonth(), args.value.getDate());
                    }

                    if (vm.StartTime) {

                        vm.StartTime.setFullYear(args.value.getFullYear(), args.value.getMonth(), args.value.getDate());
                    }

                    if (vm.EndTime) {

                        vm.EndTime.setFullYear(args.value.getFullYear(), args.value.getMonth(), args.value.getDate());
                    }

                    cafm.rb.form.helpers.bookingDateTimeChanged(args);
                }
            },
            StartTime: function (args) {

                let vm = args.sender;
                // check has value as the time will be null when not valid
                if (args.value) {
                    if (!vm.StartDateTime) {
                        vm.StartDateTime = args.value;
                    }
                    else {
                        vm.StartDateTime.setHours(args.value.getHours(), args.value.getMinutes());
                    }
                    if (vm.StartDate.getDate() != args.value.getDate() || vm.StartDate.getMonth() != args.value.getMonth() || vm.StartDate.getFullYear() != args.value.getFullYear()) {
                        vm.StartDateTime = new Date(vm.StartDate.getFullYear(), vm.StartDate.getMonth(), vm.StartDate.getDate(), args.value.getHours(), args.value.getMinutes(), 0, 0);
                    }
                }
                else {
                    vm.StartDateTime = null;
                }
                cafm.rb.form.helpers.bookingDateTimeChanged(args);
            },
            EndTime: function (args) {

                let vm = args.sender;
                // check has value as the time will be null when not valid
                if (args.value) {
                    if (!vm.EndDateTime) {
                        vm.EndDateTime = args.value;
                    }
                    else {
                        vm.EndDateTime.setHours(args.value.getHours(), args.value.getMinutes());
                    }
                    if (vm.StartDate.getDate() != args.value.getDate() || vm.StartDate.getMonth() != args.value.getMonth() || vm.StartDate.getFullYear() != args.value.getFullYear()) {                        
                        vm.EndDateTime = new Date(vm.StartDate.getFullYear(), vm.StartDate.getMonth(), vm.StartDate.getDate(), args.value.getHours(), args.value.getMinutes(), 0, 0);
                    }
                }
                else {
                    vm.EndDateTime = null;
                }
                cafm.rb.form.helpers.bookingDateTimeChanged(args);
            },
            setField: function (args) {

                if (cafm.rb.form.handlers.field.preventChangeHandler === true) return;

                var handler = cafm.rb.form.handlers.field[args.field];

                if (isFunc(handler)) {

                    handler(args);
                }
            }
        },
        main: {

            calendar: function () {

                var viewModel = cafm.views.getMainFormViewModel();
                cafm.rb.bookingId = viewModel.ID;
                cafm.rb.scheduler.roomLocality = viewModel.LocalityDescription;
                cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingCalendar);
            },
            cancel: function () {

                cafm.nav.router.restorePreviousRoute();
            },
            createbooking: function(){
                
                cafm.rb.form.handlers.main.saveBooking();
            },
            deletebooking: function () {
                let rb = cafm.views.getMainFormViewModel(),
                    isOcc = cafm.util.guidHasValue(rb.ScheduleOccurrenceId);
                cafm.util.yesNoDialogue({
                    message: isOcc ? cafm.res.str.MessageDeleteOccurrence : cafm.res.str.MessageDeleteRoomBooking,
                    yesHandler: function () {
                        cafm.actions.execute({
                            url: cafm.url.api(isOcc ? 'RoomBooking/DeleteBookingOccurrence' : 'RoomBooking/DeleteBooking'),
                            values: isOcc ? cafm.util.createParentChildId(rb.ID, rb.ScheduleOccurrenceId) : cafm.util.idData(rb.ID),
                            loaderSelector: '#mainContentPane',
                            preventValidate: true,
                            success() {
                                cafm.nav.router.navigateDefault();
                            }
                        });
                    }
                });
            },
            print: function () {

                window.print();
            },
            recurrenceUpdated: function(recurrencePattern){

                var rb = cafm.views.getMainFormViewModel();
                cafm.rb.form.helpers.showRecurringLink(rb);
                rb.set('RecurrencePattern', recurrencePattern);
                rb.set('RecurrenceString', recurrencePattern.Description);
                rb.set('IsRecurringBooking', true);
                $('#addBookingTimes').hide();
                $('#recurrenceString').show();
            },
            reconfirmbooking() {
                let rb = cafm.views.getMainFormViewModel();
                cafm.actions.execute({
                    url: cafm.url.api('RoomBooking/ReconfirmBookingOccurrence'),
                    values: cafm.util.createParentChildId(rb.ID, rb.ScheduleOccurrenceId),
                    loaderSelector: '#main,[data-key="ReconfirmBooking"]',
                    success() {
                        cafm.msg.showMessageInWindow({
                            title: cafm.res.str.MessageRoomBookingReconfirmed,
                            type: cafm.enums.MessageType.Success,
                            closeOnClick: true,
                            onClose() {
                                cafm.nav.router.navigateDefault();
                            }
                        });
                    }
                });
            },
            recurrenceWindowClosed: function() {
                
                var rb = cafm.views.getMainFormViewModel();

                if (!rb.RecurrencePattern) {

                    rb.set('IsRecurringBooking', false);
                }
            },
            saveBooking: function(onSuccess){

                var roomBooking = cafm.views.getMainFormViewModel();

                var serverDateTime = cafm.rb.form.helpers.ensureServerBookingDates(roomBooking);

                if (serverDateTime) {

                    roomBooking.set(serverDateTime);
                }

                cafm.actions.execute({

                    url: cafm.url.api('RoomBooking/Save'),
                    values: roomBooking,
                    elementId: cafm.res.consts.ElementId_MainForm,
                    loaderSelector: '#mainContentPane,#sub-header-toolbar [data-key="CreateBooking"],#sub-header-toolbar [data-key="UpdateBooking"]',
                    loaderText: cafm.res.str.MessageSavingRoomBooking,
                    validate(action) {
                        let settings = cafm.rb.settings;
                        if (settings.costCodeExactLength || settings.costCodeMinLength || settings.costCodeMaxLength) {
                            action.set("valid", cafm.rb.form.helpers.validateCostCode());
                        }
                    },
                    valuesConverter: function (rb) {
                        cafm.rb.form.helpers.changeBookingStartEndToUTCOnSave(rb);//This happens after client validate
                    }, 
                    statusCodeFuncs: {

                        200: function () {

                            cafm.util.callFunctionAsync({
                                func: function () {
                                    cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingConfirmation, {
                                        bookingId: roomBooking.ID
                                    });
                                },
                                timeout: 250
                            })
                        },
                        409: function (res) {

                            cafm.msg.showFormMessages({

                                clientData: res
                            });

                            if (cafm.util.hasItem(res.Clashes)) {

                                cafm.rb.form.helpers.showClashes({

                                    clashes: res.Clashes,
                                    showClashItem: true
                                });
                            }
                        }
                    }
                });
            },
            updatebooking: function () {

                cafm.rb.form.handlers.main.saveBooking();
            }
        },
        misc: {

            contactLookupSelected: function (args) {

                var vm = cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingCalendar) ? cafm.views.getActionWindowViewModel() : cafm.views.getMainFormViewModel();

                cafm.rb.form.handlers.misc.personLookupSelected({

                    personId: args.value,
                    emailField: 'ContactEmail',
                    telField: 'ContactTelNo',
                    viewModel: vm
                });
            },
            hostLookupSelected: function (args) {
                                
                cafm.rb.form.handlers.misc.personLookupSelected({

                    personId: args.value,
                    emailField: 'HostEmail',
                    telField: 'HostTelNo',
                    viewModel: cafm.views.getActionWindowViewModel()
                });
            },
            personLookupSelected: function (args) {

                cafm.actions.execute({

                    url: cafm.url.api('Person/GetPerson/{0}', args.personId),
                    method: 'GET',
                    statusCodeFuncs: {

                        200: function (person) {

                            var vm = args.viewModel;
                            if (person.EmailAddress) {

                                vm.set(args.emailField, person.EmailAddress);
                            }
                            if (person.TelephoneNumberAndExtension) {

                                vm.set(args.telField, person.TelephoneNumberAndExtension);
                            }
                        }
                    }
                });
            }
        },
        optional: {

            ok: function(){

                var af = cafm.views.getActionForm(),
                    roomBooking = cafm.views.getMainFormViewModel(),
                    viewModel = cafm.views.getActionWindowViewModel().toJSON();

                // update the optional info on the room booking
                roomBooking.set(viewModel);

                var dd = $('#DepartmentID', af).data('kendoDropDownList');
                if(dd && cafm.util.guidHasValue(dd.value()))
                {
                    roomBooking.set('DepartmentDescription', dd.text());
                }
                else
                {
                    roomBooking.set('DepartmentDescription', null);
                }

                dd = $('#RoomBookingTypeCodeID', af).data('kendoDropDownList');
                if (dd && cafm.util.guidHasValue(dd.value())) {

                    roomBooking.set('RoomBookingTypeCodeDescription', dd.text());
                }
                else {

                    roomBooking.set('RoomBookingTypeCodeDescription', null);
                }

                dd = $('#AssignedRoomLayoutCodeID', af).data('kendoDropDownList');
                if (dd && cafm.util.guidHasValue(dd.value())) {

                    // update description
                    roomBooking.set('AssignedRoomLayoutCodeDescription', dd.text());

                    var layout = cafm.util.find(dd.dataSource.data(), function (item) {

                        return item.value === roomBooking.AssignedRoomLayoutCodeID;
                    })

                    // update has image flag
                    roomBooking.set('AssignedRoomLayoutHasDefaultPhoto', layout && layout.customValue3 === true);

                    // now update the field and show the image if the flag is true
                    if (roomBooking.AssignedRoomLayoutHasDefaultPhoto) {
                        
                        var arl = $('#AssignedRoomLayoutCodeDescription')
                        arl.html(cafm.rb.form.handlers.optional.formattedRoomLayout(arl));
                    }
                }
                else {

                    roomBooking.set('AssignedRoomLayoutCodeDescription', null);
                }

                cafm.views.closeActionWindow();
            },
            cancel:  function(){

                cafm.toolbar.standardActionToolbar.cancel();
            },
            load: function(panel){

                panel.find('#contactLookup').data('onLookupSelected', cafm.rb.form.handlers.misc.contactLookupSelected);
                panel.find('#hostLookup').data('onLookupSelected', cafm.rb.form.handlers.misc.hostLookupSelected);
                panel.find('#ManualAttendees').data('kendoNumericTextBox').bind('change', cafm.rb.form.handlers.optional.capacityChanged);

                // get the  room booking
                var rb = cafm.views.getMainFormViewModel();

                // now determine the capacity
                var cap = rb.ManualAttendees;

                // get count of attendees not deleted
                var attCap = cafm.util.count(rb.Attendees.toJSON(), function (att) {

                    return !att.IsDeleted;
                });

                // filter layouts
                // ensure max attendee count is used
                cafm.rb.form.helpers.filterLayoutByCapacity(cap > attCap ? cap : attCap);
            },
            capacityChanged: function (args) {

                // now determine the capacity
                var cap = args.sender.value(),
                    rb = cafm.views.getMainFormViewModel();

                // get count of attendees not deleted
                var attCap = cafm.util.count(rb.Attendees.toJSON(), function (att) {

                    return !att.IsDeleted;
                });

                // filter layouts
                // ensure max attendee count is used
                cafm.rb.form.helpers.filterLayoutByCapacity(cap > attCap ? cap : attCap);
            },
            formattedRoomLayout: function (element) {
                /// <summary>Displays a formatted room layout, for a read only field using the client value formatter</summary>
                /// <param name="e" type="Object">Args object, space = the total space between the element and viewport edge, title = the window title</param>
                /// <returns type="string">The text / html to show</param>

                var rb = cafm.views.getMainFormViewModel(), title = element.text();

                if (rb.AssignedRoomLayoutHasDefaultPhoto) {

                    // create thumbnail
                    var thumbHtml = element.setupImageThumbWithPopupWindow({
                        title: title,
                        linkTitle: cafm.res.str.LabelViewRoomLayout,
                        alt: title,
                        thumbUrl: cafm.url.api('RoomLayoutCode/GetDefaultImage?roomId={0}&assignedLayoutCodeId={1}&width={2}', [rb.RoomId, rb.AssignedRoomLayoutCodeID, $('.bookingDescription input[type="text"]').width()]),
                        imageUrl: function () {

                            return cafm.url.api('RoomLayoutCode/GetDefaultImage?roomId={0}&assignedLayoutCodeId={1}', [rb.RoomId, rb.AssignedRoomLayoutCodeID])
                        },
                        returnType: 'html', // return html back please!
                        errorThumbWidth: '200' // don't want the error image to take up much screen space
                    })
                    
                    // return title plus the thumb html
                    return title + thumbHtml;
                }
                else {

                    return title;
                }
            }
        },
        search: {
            
            amendsearch: function () {

                $('#roomListWrapper').hide();
                $('#roomFiltersWrapper').show();

                var tb = $('.action-buttons');
                tb.find('[data-key="AmendSearch"]').hide();
                tb.find('[data-key="FindRooms"]').show();
            },
            findrooms: function (e) {
                
                if (!cafm.views.getMainForm().validateElement()) {

                    return;
                }

                var vm = cafm.views.getMainFormViewModel();

                if (vm.StartDate) {

                    var bookedFrom, bookedTo;

                    if (vm.StartTime) {

                        bookedFrom = new Date(vm.StartDate.getTime())
                        bookedFrom.setHours(vm.StartTime.getHours());
                        bookedFrom.setMinutes(vm.StartTime.getMinutes());
                    }
                                        
                    if (vm.EndTime) {

                        bookedTo = new Date(vm.StartDate.getTime());
                        bookedTo.setHours(vm.EndTime.getHours());
                        bookedTo.setMinutes(vm.EndTime.getMinutes());
                    }
                }

                var critLocTZ = cafm.util.find(cafm.cache.get(cafm.res.consts.CacheKey_UserTimeZones), function (z) {
                    return z.LocalityID == vm.LocationID;
                });

                //If default Location is not set, use Sesssion Time Zone
                var critTZName = critLocTZ ? critLocTZ.Name : cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);

                var sessionbookdatefrom = bookedFrom;
                bookedFrom = cafm.web.funcs.fromSessionToUTCDateTime(bookedFrom, true, critTZName);
                bookedTo = cafm.web.funcs.fromSessionToUTCDateTime(bookedTo, true, critTZName);
                
                vm.set('BookedFrom', bookedFrom);
                vm.set('BookedTo', bookedTo);

                vm = vm.toJSON();

                if (vm.RoomLayoutCodeID) {

                    vm.RoomLayoutCodeID = cafm.util.getItemValue(vm.RoomLayoutCodeID);
                }

                var lv = $('#roomListView .cLv');

                // set criteria and refresh ds
                lv.setCriteria(vm).refreshListDS({ resetPage: true });

                $('#roomFiltersWrapper').hide();
                $('#roomListWrapper').show();
                $('#roomListTitle').text(cafm.res.str.LabelAvailableRoomsFor + (' ' + moment(sessionbookdatefrom).format('DD/MM/YYYY hh:mm A')));

                $('#amendSearch').click(function () {

                    $('#roomListWrapper').hide();
                    $('#roomFiltersWrapper').show();

                    var tb = $('.action-buttons');
                    tb.find('[data-key="AmendSearch"]').hide();
                    tb.find('[data-key="FindRooms"]').show();
                });

                var tb = $('.action-buttons');
                tb.find('[data-key="FindRooms"]').hide();
                tb.find('[data-key="AmendSearch"]').show();
            },
            onRoomDataRetrieved: function(rooms){

                if (isArray(rooms) && rooms.length == 1) {

                    cafm.rb.form.startNewBooking(rooms[0]);
                }
                else if (cafm.util.hasItem(rooms)) {

                    $.each(rooms, function (i, room) {

                        var facStr = [];
                        if (room.HasFixedProjector) {

                            facStr.push('F');
                        }
                        if (room.HasVideoConferencingFacilities) {

                            facStr.push('V');

                        }
                        if (room.HasWhiteboard) {

                            facStr.push('W');
                        }
                        room.Facilities = facStr.join('');
                    });
                }
            },
            onRoomSelectionChanged: function (e) {

                cafm.rb.form.startNewBooking(e.sender.getSelected());
            }
        }
    },
    helpers: {
        getBookingDateTimeText: function (start, end) {
            /// <summary>Returns text representation of Start/End Date Time</summary>
            /// <param name="start" type="DateTime">The Start DateTime</param>
            /// <param name="end" type="DateTime">The End DateTime</param>
            return '{0}, {1}, {2} - {3}'.format(kendo.toString(start, 'dddd'), kendo.toString(start, 'd'), kendo.toString(start, 't'), kendo.toString(end, 't'));
        },
        changeBookingStartEndToLocalOnLoad(rbObj) {
            //Ideally this should happen inside the BookingDateTimePicker.cshtml, by adding custom kendo binding handler for this control but that will take time!
            if (rbObj && (rbObj.IsFreshFromServer || rbObj.IsNew==false)) {

                rbObj.StartDateTime = cafm.web.funcs.fromUTCToSessionDateTime(rbObj.StartDateTime);
                rbObj.EndDateTime = cafm.web.funcs.fromUTCToSessionDateTime(rbObj.EndDateTime);
                rbObj.BookingDateTime = cafm.rb.form.helpers.getBookingDateTimeText(rbObj.StartDateTime, rbObj.EndDateTime);
                if (rbObj.BookingDateTimes) {
                    rbObj.BookingDateTimes.forEach(function (item) {
                        item.StartDateTime = cafm.web.funcs.fromUTCToSessionDateTime(item.StartDateTime);
                        item.EndDateTime = cafm.web.funcs.fromUTCToSessionDateTime(item.EndDateTime);
                    });
                }
                if (cafm.util.hasItem(rbObj.Equipment)) {
                    rbObj.Equipment.forEach(item => {
                        item.FromTime = cafm.web.funcs.fromUTCToSessionDateTime(item.FromTime);
                        item.ToTime = cafm.web.funcs.fromUTCToSessionDateTime(item.ToTime);
                    });
                }
                if (cafm.util.hasItem(rbObj.Services)) {
                    rbObj.Services.forEach(item => {
                        item.FromTime = cafm.web.funcs.fromUTCToSessionDateTime(item.FromTime);
                        item.ToTime = cafm.web.funcs.fromUTCToSessionDateTime(item.ToTime);
                    });
                }
                rbObj.IsFreshFromServer = false;
            }
        },
        changeBookingStartEndToUTCOnSave(rbVm) {
            if (rbVm) {
                rbVm.set('StartDateTime', cafm.web.funcs.fromSessionToUTCDateTime(rbVm.get('StartDateTime')));
                rbVm.set('EndDateTime', cafm.web.funcs.fromSessionToUTCDateTime(rbVm.get('EndDateTime')));
                if (rbVm.BookingDateTimes) {
                    rbVm.BookingDateTimes.forEach(item => {
                        item.StartDateTime = cafm.web.funcs.fromSessionToUTCDateTime(item.StartDateTime);
                        item.EndDateTime = cafm.web.funcs.fromSessionToUTCDateTime(item.EndDateTime);
                    });
                }
                if (cafm.util.hasItem(rbVm.Equipment)) {
                    rbVm.Equipment.forEach(item => {
                        item.FromTime = cafm.web.funcs.fromSessionToUTCDateTime(item.FromTime);
                        item.ToTime = cafm.web.funcs.fromSessionToUTCDateTime(item.ToTime);
                    });
                }
                if (cafm.util.hasItem(rbVm.Services)) {
                    rbVm.Services.forEach(item => {
                        item.FromTime = cafm.web.funcs.fromSessionToUTCDateTime(item.FromTime);
                        item.ToTime = cafm.web.funcs.fromSessionToUTCDateTime(item.ToTime);
                    });
                }
            }
        },
        addAdhocDatetime: function(args) {

            var fieldSet = $('#ahHocFieldSet'),
                fieldGroups = fieldSet.find('.fieldGroup'),
                lastFieldGroup = fieldGroups.last(),
                count = fieldSet.data('count'),
                fgHtml = fieldSet.data('fieldsHtml');

            fgHtml = fgHtml.replace(/StartDate/g, 'StartDate' + count);
            fgHtml = fgHtml.replace(/StartTime/g, 'StartTime' + count);
            fgHtml = fgHtml.replace(/EndTime/g, 'EndTime' + count);

            var newFg = $('<div/>', {

                'class': 'fieldGroup',
                html: fgHtml,
                data: {
                    index: count
                }
            }).hide();

            cafm.rb.form.helpers.modifyAdHocFieldGroup(newFg);
            newFg.insertAfter(lastFieldGroup);

            var rb = args.roomBooking,
                viewModel = cafm.views.getActionWindowViewModel(),
                startTime, endTime;

            if(args.startDateTime) {

                startTime = new Date(args.startDateTime);
                viewModel.set('StartDate' + count, startTime);
            }
            else {
                
                startTime = new Date(rb.StartDateTime);
            }

            if (args.endDateTime) {

                endTime = new Date(args.endDateTime);
            }
            else {

                endTime = new Date(rb.EndDateTime);
            }

            viewModel.set('StartTime' + count, startTime);
            viewModel.set('EndTime' + count, endTime);
            cafm.views.bindActionWindowViewModel(viewModel);

            newFg.append($('<a />', {

                'class': 'removeLink',
                click: cafm.rb.form.handlers.adhoc.remove
            }));

            newFg.find('.cfField:not(.cfChildField)').append($('<div />', {

                id: 'adHocDateMsg' + count,
                'class': 'adHocValPlc'
            }));

            count++;
            fieldSet.data('count', count);

            newFg.prepareForm();
            cafm.rb.form.helpers.setMinDatePickers(newFg, rb.StartDateTime);
            cafm.rb.form.helpers.setMinMaxTimePickers(newFg, rb.MinTime, rb.MaxTime);
            newFg.show();
        },
        addHistory: function (roomBooking) {
            cafm.nav.router.addRouteToHistory({
                itemKey: roomBooking.ID,
                itemTitle: '[{0}] {1}'.format(roomBooking.Reference, roomBooking.Description),
                itemDetail: [roomBooking.BookingDateTime, '\r\n\r\n', roomBooking.Subject].join(''),
                itemType: cafm.enums.HistoryItemType.RoomBooking,
                navUrl: '{0}#{1}/{2}'.format(document.location.pathname, 'editBooking', roomBooking.ID)
            });
        },
        appendAddLink: function (args) {

            if (!args.target.find('.addLink').length) {

                args.target.append($('<a />', {

                    id: args.id,
                    'class': 'addLink',
                    text: cafm.res.str.LabelAdd,
                    click: args.handler
                }));
            }
        },
        appendEditLink: function (args) {
            
            if (!args.target.find('.editLink').length) {

                args.target.append($('<a />', {

                    id: args.id,
                    'class': 'editLink',
                    text: cafm.res.str.LabelEdit,
                    click: args.handler
                }));
            }
        },
        applyCostCodeRestriction() {
            let tbox = $("#CostCode");
            tbox.off("input").on("input", function (e) {
                cafm.rb.form.helpers.validateCostCode();
            });
        },
        bookingDateTimeChanged: function(args) {

            var n = cafm.enums.Navigatable;
            if (!cafm.nav.isNav(n.RoomBookingEditBooking, n.RoomBookingNewBooking)) {

                return;
            }

            var rb = args.sender;
            var rebind;
            var resetUiTimes;

            if (cafm.util.hasItem(rb.Equipment)) {

                rb.Equipment.forEach(function (eqItem) {

                    if (eqItem.UseMeetingTimes) {

                        resetUiTimes = true;
                    }
                    else {

                        eqItem.FromTime.setFullYear(rb.StartDateTime.getFullYear());
                        eqItem.FromTime.setMonth(rb.StartDateTime.getMonth());
                        eqItem.FromTime.setDate(rb.StartDateTime.getDate());
                        eqItem.ToTime.setFullYear(rb.StartDateTime.getFullYear());
                        eqItem.ToTime.setMonth(rb.StartDateTime.getMonth());
                        eqItem.ToTime.setDate(rb.StartDateTime.getDate());

                        if (eqItem.FromTime < rb.StartDateTime || eqItem.FromTime > rb.EndDateTime) {

                            resetUiTimes = true;
                        }
                        if (eqItem.ToTime > rb.EndDateTime || eqItem.ToTime < rb.StartDateTime) {

                            resetUiTimes = true;
                        }
                    }

                    if (resetUiTimes) {
                           
                        eqItem.set('UseMeetingTimes', true);
                        eqItem.set('FromTime', rb.StartDateTime);
                        eqItem.set('ToTime', rb.EndDateTime);
                        rebind = true;
                    }
                });

                if (rebind) {

                    cafm.rb.eq.helpers.refreshEquipment();
                }
            }

            if (cafm.util.hasItem(rb.Services)) {

                rb.Services.forEach(function (svcItem) {

                    if (svcItem.UseMeetingTimes) {

                        resetUiTimes = true;
                    }
                    else {

                        svcItem.FromTime.setFullYear(rb.StartDateTime.getFullYear());
                        svcItem.FromTime.setMonth(rb.StartDateTime.getMonth());
                        svcItem.FromTime.setDate(rb.StartDateTime.getDate());

                        if (svcItem.FromTime < rb.StartDateTime || svcItem.FromTime > rb.EndDateTime) {

                            resetUiTimes = true;
                        }
                        if (svcItem.ToTime > rb.EndDateTime || svcItem.ToTime < rb.StartDateTime) {

                            resetUiTimes = true;
                        }
                    }

                    if (resetUiTimes) {

                        svcItem.set('UseMeetingTimes', true);
                        svcItem.set('FromTime', rb.StartDateTime);
                        svcItem.set('ToTime', rb.EndDateTime);
                        rebind = true;
                    }
                });

                if (rebind) {

                    cafm.rb.svc.helpers.refreshServices();
                }
            }

            if (rb.IsRecurringBooking && rb.RecurrencePattern) {

                rb.RecurrencePattern.StartDateTime = cafm.web.funcs.fromSessionToUTCDateTime(rb.StartDateTime);
                rb.RecurrencePattern.EndDateTime = cafm.web.funcs.fromSessionToUTCDateTime(rb.EndDateTime);

                // if the date is changed and pattern is weekly we need to change the week day selected if it's a single day 
                if (rb.RecurrencePattern.PatternFrequency == cafm.enums.RecurrencePatternFrequency.Weekly && cafm.recurrence.helpers.isSingleDayOfWeek(rb.RecurrencePattern.DaysOfWeek)) {

                    // reset the day of week
                    rb.RecurrencePattern.DaysOfWeek = cafm.recurrence.helpers.getDayOfWeekFromDate(rb.StartDateTime);
                }

                // description changed handleer
                rb.RecurrencePattern.descriptionChangeHandler = function (description) {

                    rb.set('RecurrenceString', description);
                    delete rb.RecurrencePattern.descriptionChangeHandler;
                };

                // trigger the change
                rb.RecurrencePattern.trigger('change');
            }

            if (rb.StartDateTime && rb.EndDateTime) {
                // refresh the booking date time on the server
                cafm.actions.execute({
                    url: cafm.url.api('RoomBooking/SetBookingStartEnd'),
                    values: {
                        BookingId: rb.ID,
                        StartDateTime: rb.StartDateTime,
                        EndDateTime: rb.EndDateTime
                    },
                    valuesConverter: function (rb) {
                        cafm.rb.form.helpers.changeBookingStartEndToUTCOnSave(rb);
                    }, 
                })
            }
        },
        ensureServerBookingDates: function (viewModel, suffix) {

            var startDateFieldName = 'StartDate';
            var startTimeFieldName = 'StartTime';
            var endTimeFieldName = 'EndTime';

            if (isDefined(suffix) && suffix > 0) {

                startDateFieldName += suffix;
                startTimeFieldName += suffix;
                endTimeFieldName += suffix;
            }

            var sd = viewModel.get(startDateFieldName);

            if (sd) {

                var st = viewModel.get(startTimeFieldName);
                var et = viewModel.get(endTimeFieldName);

                if (st) {

                    sd.setHours(st.getHours(), st.getMinutes(), 0, 0);
                }

                if (et) {

                    et.setFullYear(sd.getFullYear());
                    et.setMonth(sd.getMonth(), sd.getDate());
                }

                return {

                    StartDateTime: st ? sd : null,
                    EndDateTime: et
                };
            }
            else {

                return null;
            }
        },
        filterLayoutByCapacity: function(cap) {

            var layDrop = $('select#AssignedRoomLayoutCodeID'),
                kLayDrop = layDrop.data('kendoDropDownList'),
                items = layDrop.data('items'),
                filtered;

            // saftey check, if there's no layout then return and do nothing
            if (!cafm.util.hasItem(items)) {

                return;
            }

            if (!cap) {

                // include all if no capacity specified
                filtered = items;
            }
            else {

                // filter the layouts by capacity
                filtered = cafm.util.where(items, function (item) {

                    return !cafm.util.guidHasValue(item.value) || (item.customValue1 <= cap && item.customValue2 >= cap);
                });
            }

            // set the dropdown data source
            kLayDrop.setDataSource(new kendo.data.DataSource({
                data: filtered
            }));

            // get the view model
            var vm = cafm.views.getActionWindowViewModel();

            // ensure no layout on booking if none meet capacity requirements
            if (!cafm.util.hasItem(filtered)) {

                vm.set('AssignedRoomLayoutCodeID', cafm.guid.empty);
                vm.set('AssignedRoomLayoutCodeDescription', '');
                kLayDrop.enable(false);
                return;
            }
            else {

                kLayDrop.enable(true);
            }

            // collect vars to check
            var hasRoomLayout = cafm.util.guidHasValue(vm.AssignedRoomLayoutCodeID);
            var exists = cafm.util.exists(filtered, function (item) { return item.value == vm.AssignedRoomLayoutCodeID; });

            // if there's only only match or last selection has been filtered out
            if (!exists && hasRoomLayout) {

                vm.set('AssignedRoomLayoutCodeID', filtered[0].value);
                vm.set('AssignedRoomLayoutCodeDescription', filtered[0].text);
            }

            // otherwise ensure the room layout is still selected            
            // we have to do this to ensure reselection after changing the data source
            if (cafm.util.guidHasValue(vm.AssignedRoomLayoutCodeID)) {

                kLayDrop.value(vm.AssignedRoomLayoutCodeID);
                kLayDrop.text(vm.AssignedRoomLayoutCodeDescription);
            }
        },
        getNextDefaultBookingTimes: function (roomBooking) {

            var rbs = cafm.getClientSettings().roomBookingSettings;
            var cs = roomBooking ? roomBooking.MinTime : rbs.calendarWindowStart;
            var ce = roomBooking ? roomBooking.MaxTime : rbs.calendarWindowEnd;
            var duration = rbs.defaultBookingDuration;

            // set working vars
            var startTime, endTime, now = new Date();
            now.setSeconds(0, 0);

            // add 30 mins onto now for start time
            startTime = cafm.util.addMinutes(now, 30);
            var startMins = startTime.getMinutes();

            // round down to 0 if 1-29
            if (startMins > 0 && startMins < 30) {

                startTime.setMinutes(0);
            }
                // round down to 30 if over 30 mins
            else if (startMins > 30) {

                startTime.setMinutes(30);
            }

            // check we're not outside the working calendar, if we set start to nearest available time
            if (startTime.getHours() > ce.getHours() || (startTime.getHours() == ce.getHours() && startTime.getMinutes() >= ce.getMinutes())) {

                // later than the calendar day end, set to first available tomorrow
                startTime = cafm.util.addMinutes(now, 60 * 24);
                startTime.setHours(cs.getHours());
                startTime.setMinutes(cs.getMinutes());
            }
            else if (startTime.getHours() < cs.getHours() || (startTime.getHours() == ce.getHours() && startTime.getMinutes() < cs.getMinutes())) {

                // earlier than the calendar day start, set to first available today
                startTime.setHours(cs.getHours());
                startTime.setMinutes(cs.getMinutes());
            }

            // add duration onto start for end
            endTime = cafm.util.addMinutes(startTime, duration);

            // if end time exceeds the max then set to max
            if (endTime.getHours() > ce.getHours() && (endTime.getHours() == ce.getHours() && endTime.getMinutes() >= ce.getMinutes())) {

                endTime.setHours(ce.getHours());
                endTime.setMinutes(ce.getMinutes());
            }

            return {

                StartDate: startTime,
                StartTime: startTime,
                EndTime: endTime
            }
        },
        modifyAdHocFieldGroup: function (fieldGroup) {

            fieldGroup.find('[id]').each(function (i, el) {

                el = $(el);
                el.attr('class', el.attr('class') + ' ' + el.attr('id')).removeAttr('id');
            });
        },
        rebindBooking(booking) {
            let rb = cafm.views.getMainFormViewModel();
            rb.set(booking);
            cafm.rb.eq.helpers.refreshEquipment();
            cafm.rb.svc.helpers.refreshServices();
            cafm.rb.att.helpers.refreshAttendees();
        },
        renderBookingDateTimes: function (roomBooking) {

            var containerEl = $('#bookingTimesContainer');
            var linkEl = $('#bookingTimesLink');

            var hideBookingDateTimes = function () {

                containerEl.hide();
                linkEl.hide();
            }

            if (cafm.util.hasItem(roomBooking.BookingDateTimes)) {

                cafm.util.ensureDates(roomBooking, ['StartDateTime', 'EndDateTime']);
                cafm.util.ensureAllDates(roomBooking.BookingDateTimes, ['StartDateTime', 'EndDateTime']);

                cafm.rb.form.bookingDateTimes = [];

                roomBooking.BookingDateTimes.forEach(function (item) {

                    if (cafm.util.dateTimesAreSame(item.StartDateTime, roomBooking.StartDateTime)) {

                        return;
                    }

                    var dateStr = [kendo.toString(item.StartDateTime, 'dddd')];
                    dateStr.push(', ');
                    dateStr.push(kendo.toString(item.StartDateTime, 'd'));
                    dateStr.push(', ');
                    dateStr.push(kendo.toString(item.StartDateTime, 't'));
                    dateStr.push(' - ');
                    dateStr.push(kendo.toString(item.EndDateTime, 't'));

                    cafm.rb.form.bookingDateTimes.push({
                        BookingDateTime: dateStr.join(''),
                        StartDateTime: item.StartDateTime
                    });
                });

                if (!containerEl.length) {

                    containerEl = $('<div/>', {

                        id: 'bookingTimesContainer',
                        'class': 'bookingTimesContainer'
                    }).hide().insertAfter('#bookingDateTime');

                    listEl = $('<ul/>', {

                        id: 'bookingTimesList',
                        'class': 'bookingTimesList'
                    }).appendTo(containerEl);

                    var template = '<li>#=BookingDateTime#{0}</li>';

                    if (roomBooking.IsReadOnly || roomBooking.IsRecurringBooking) {

                        template = template.format('');
                    }
                    else {

                        template = template.format('<a class="removeLink"></a>');
                    }

                    var isConf = cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingConfirmation);

                    listEl.kendoListView({
                        dataSource: {

                            transport: {
                                read: function (options) {

                                    options.success(cafm.rb.form.bookingDateTimes);
                                }
                            },
                            pageSize: isConf ? 1000000 : 5
                        },
                        template: template,
                        autoBind: true
                    });

                    if (!isConf) {
                        
                        $('<ul/>', {

                            id: 'bookingTimesPager',
                            'class': 'bookingTimesPager cLvPager'
                        }).insertAfter(listEl).kendoPager({
                            dataSource: listEl.data('kendoListView').dataSource
                        });
                    }
                }
                else {

                    listEl = containerEl.find('#bookingTimesList');
                    $('#bookingTimesList').data('kendoListView').dataSource.read();
                }

                var ds = listEl.data('kendoListView').dataSource;

                // show the pager if total exceeds page size
                // hide the pager if total is less than or equal to page size
                if (ds.total() <= ds.pageSize()) {

                    containerEl.find('.cLvPager').hide();
                }
                else {

                    containerEl.find('.cLvPager').show();
                }

                // ensure the current page is always visible by determining max page
                var maxPage = Math.ceil(ds.total() / ds.pageSize());

                // ensure max page is at least 1
                if (maxPage < 1) maxPage = 1;

                // if previous page selection was larger then reset the page
                if (maxPage < ds.page()) ds.page(maxPage);

                if (!cafm.rb.form.bookingDateTimes.length) {

                    hideBookingDateTimes();
                }

                $('#bookingTimesList').off('click').on('click', '.removeLink', cafm.rb.form.handlers.adhoc.removeRecentlyAdded);
            }
            else {

                hideBookingDateTimes();
            }
        },
        setupBookingDateTimePicker: function (args) {

            var wrapper = args.element;
            var viewModel = args.element.getParentViewModel();
            var rbs = cafm.getClientSettings().roomBookingSettings;

            if (viewModel) {

                cafm.util.ensureDates(viewModel, ['StartDateTime', 'EndDateTime']);

                if(isNullOrUndefined(viewModel.StartDate)) {

                    viewModel.set('StartDate', viewModel.StartDateTime);
                }
                if(isNullOrUndefined(viewModel.StartTime)) {

                    viewModel.set('StartTime', viewModel.StartDateTime);
                }
                if(isNullOrUndefined(viewModel.EndTime)) {

                    viewModel.set('EndTime', viewModel.EndDateTime);
                }
            }

            var min;
            var max;

            if (args.minTime) {

                min = args.minTime;
            }
            else {

                min = rbs.calendarWindowStart;
            }

            if (args.maxTime) {

                max = args.maxTime;
            }
            else {

                max = rbs.calendarWindowEnd;
            }

            cafm.rb.form.helpers.setMinMaxTimePickers(wrapper, min, max);
            cafm.rb.form.helpers.setMinDatePickers(wrapper, new Date());

            wrapper.find('[name="StartDate"]').attr('data-bookingdatetime-msg', cafm.res.str.MessageEnterValidStartDate);
        },
        setMinMaxTimePickers: function (element, minTime, maxTime) {

            element.find('[data-role="timepicker"]').each(function (i, el) {

                var ktp = $(el).data('kendoTimePicker');
                ktp.min(minTime);
                ktp.max(maxTime);
            });
        },
        setMinDatePickers: function (element, minTime) {

            element.find('[data-role="datepicker"]').each(function (i, el) {

                var kdp = $(el).data('kendoDatePicker');
                kdp.min(minTime);
            });
        },
        showBookingDateTimesLink: function(expanded){
            
            let btl = $('#bookingTimesLink');

            if (btl.length) {

                btl.removeClass('collapseLink').show();
            }
            else {

                $('#bookingDateTime').append($('<a />', {

                    'id': 'bookingTimesLink',
                    'class': 'expandLink' + (expanded ? ' collapseLink' : ''),
                    click: cafm.rb.form.handlers.adhoc.expand
                }));
            }
            
            $('#IsRecurringBooking').setCheckboxDisabled(true);
        },
        showRecurringLink: function (roomBooking) {

            var bdt = $('#bookingDateTime');

            if (!bdt.find('.recurrenceLink').length) {

                var clickHandler = function () {

                    var rb = cafm.views.getMainFormViewModel();
                    cafm.recurrence.handlers.openForm(rb.RecurrencePattern, cafm.rb.form.handlers.main.recurrenceUpdated);
                };

                $('#bookingDateTime').append($('<span />', {

                    'id': 'recurrenceLink',
                    'class': 'recurrenceLink',
                    title: roomBooking.RecurrenceString
                }));

                if (!roomBooking.IsReadOnly) {

                    cafm.rb.form.helpers.appendEditLink({

                        target: $('#IsRecurringBooking').parent(),
                        handler: clickHandler
                    });
                }

                $('#recurrenceString').show();
            }
        },
        showClashes: function (args) {

            args.clashes.forEach(function (clash) {

                if (clash.Type === cafm.enums.ScheduleItemType.Room) {

                    $('#RoomDescription,#LocalityTrail').addClass('clashingItem');
                }

                if (args.showClashItem) {

                    cafm.rb.form.helpers.showClashItem(clash);
                }
            });
        },
        showClashesIfAny: function (roomBooking) {

            // if there's no booking assume main form and attempt to get it
            if (!roomBooking) {

                roomBooking = cafm.views.getMainFormViewModel();
            }

            // show clashes if there are some
            if (roomBooking && cafm.util.hasItem(roomBooking.Clashes)) {

                cafm.rb.form.helpers.showClashes({

                    clashes: roomBooking.Clashes,
                    showClashItem: true
                });
            }
            else {

                $('.clashingItem').removeClass('clashingItem');
            }
        },
        showClashItem: function(clash) {
            
            var showGridItem = function (args) {

                var dataSource = $('#' + args.wrapperId).getGrid().getDataSource();
                var data = dataSource.data();
                var item;

                data.forEach(function (dataItem) {

                    if (args.itemExists(dataItem)) {

                        item = dataItem;
                    }
                });

                if (item) {

                    $('#{0} .k-master-row[data-uid="{1}"]'.format(args.wrapperId, item.uid)).addClass('clashingItem');
                }
            }

            switch (clash.Type) {

                case cafm.enums.ScheduleItemType.Attendee:
                    
                    showGridItem({
                        wrapperId: 'attendeeGrid',
                        itemExists: function (dataItem) {

                            return dataItem.PersonID === clash.ID;
                        }
                    });
                    break;

                case cafm.enums.ScheduleItemType.Equipment:

                    showGridItem({
                        wrapperId: 'equipmentGrid',
                        itemExists: function (dataItem) {

                            return cafm.util.exists(dataItem.Items, function (eri) {
                                return eri.IsRequired && eri.AssetId === clash.ID
                            });
                        }
                    });
                    break;
            }
        },
        toggleBookingTimes: function () {
            
            var bt = $('#bookingTimesContainer');

            var onToggle = function () {

                var disp = bt.css('display');
                var btl = $('#bookingTimesLink');

                if (disp != 'none') {

                    btl.addClass('collapseLink');
                }
                else {

                    btl.removeClass('collapseLink');
                }
            };

            if (bt.css('display') == 'none') {

                bt.slideDown(onToggle);
            }
            else {
                
                bt.slideUp(onToggle);
            }
        },
        validateCostCode() {
            let costCodeTbox = $("#CostCode");
            if (!costCodeTbox.length) return true;
            let txtNoSpaces = costCodeTbox.val().replace(/ /g, "");
            let settings = cafm.rb.settings;
            let existingCode = costCodeTbox.getParentViewModel().CostCode;
            let trimmedExistingCode = existingCode ? existingCode.replace(/ /g, "") : "";
            let invalid, warn, bypassChecks;
            let isQuickBooking = cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingCalendar);
            // check if cost code validation can be bypassed or not
            switch (settings.costCodeRequirement) {
                case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithEquipmentRequest:
                    bypassChecks = !(isQuickBooking ? cafm.views.getActionWindowViewModel().HasEquipmentRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Equipment, e => e.IsDeleted === false));
                    break;
                case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithServiceRequest:
                    bypassChecks = !(isQuickBooking ? cafm.views.getActionWindowViewModel().HasServiceRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Services, s => s.IsDeleted === false));
                    break;
                case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithEquipmentOrServiceRequest:
                    bypassChecks = !((isQuickBooking ? cafm.views.getActionWindowViewModel().HasEquipmentRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Equipment, e => e.IsDeleted === false)) || (isQuickBooking ? cafm.views.getActionWindowViewModel().HasServiceRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Services, s => s.IsDeleted === false)));
                    break;
            }
            if (bypassChecks !== true) {
                if (settings.costCodeMinLength && txtNoSpaces.length < settings.costCodeMinLength) {
                    warn = true;
                }
                else if (settings.costCodeExactLength) {
                    if (txtNoSpaces.length > settings.costCodeExactLength)
                        invalid = true;
                    else if (txtNoSpaces.length < settings.costCodeExactLength)
                        warn = true;
                }
            }

            if (!(invalid || warn) && settings.costCodeMaxLength && txtNoSpaces.length > settings.costCodeMaxLength) {
                if (txtNoSpaces.length > trimmedExistingCode.length) invalid = true; else warn = true;
            }

            let validElement = costCodeTbox.parent().find("> .k-invalid-msg");
            let validationMsg;

            if (!(invalid || warn)) {
                let hasNoCostCode = txtNoSpaces.length < 1;
                switch (settings.costCodeRequirement) {
                    case cafm.enums.RoomBookingCostCodeRequirement.Required:
                        warn = hasNoCostCode;
                        break;
                    case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithEquipmentRequest:
                        warn = (isQuickBooking ? cafm.views.getActionWindowViewModel().HasEquipmentRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Equipment, e => e.IsDeleted === false)) && hasNoCostCode;
                        break;
                    case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithServiceRequest:
                        warn = (isQuickBooking ? cafm.views.getActionWindowViewModel().HasServiceRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Services, s => s.IsDeleted === false)) && hasNoCostCode;
                        break;
                    case cafm.enums.RoomBookingCostCodeRequirement.RequiredWithEquipmentOrServiceRequest:
                        warn = ((isQuickBooking ? cafm.views.getActionWindowViewModel().HasEquipmentRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Equipment, e => e.IsDeleted === false)) || (isQuickBooking ? cafm.views.getActionWindowViewModel().HasServiceRequests : cafm.util.exists(cafm.views.getMainFormViewModel().Services, s => s.IsDeleted === false))) && hasNoCostCode;
                        break;

                }
                if (warn) {
                    validationMsg = cafm.res.str.MessageCostCodeMustBeSpecified;
                }
            }

            if (invalid === true) {
                costCodeTbox.changeVal(existingCode);
            }
            else {
                costCodeTbox.getParentViewModel().CostCode = costCodeTbox.val();
            }

            if (invalid === true || warn === true) {
                if (!validElement.length) {
                    cafm.forms.helpers.generateFieldValidationElement({
                        elementId: "cost-code-validation-msg",
                        message: validationMsg || settings.costCodeLengthMessage
                    }).insertAfter(costCodeTbox);
                }
                else {
                    validElement.show();
                }
                return false;
            }
            else {
                validElement.remove();
                return true;
            }
        }
    },
    formatCurrency: function (value) {

        var currencySymbol = cafm.rb.form.getRoomBooking().CurrencySymbol
        var formatValue = kendo.toFormatNumber(value, 'c', currencySymbol);
        var t = '<span class="lcs">{0}</span>'.format(formatValue);

        return t;
    }
}